import { cn } from "@/lib/utils";

/**
 * The OneCheckUp app icon (public/brand/app-icon.svg): a brand-teal tile with the "1" and the tick —
 * the same artwork as the favicon and the desktop app icon. Size it with className (w-9 h-9 = 36px).
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <span role="img" aria-label="OneCheckUp" className={cn("inline-flex flex-shrink-0", className)}>
      <svg viewBox="0 0 100 100" className="w-full h-full" aria-hidden>
        <rect width="100" height="100" rx="24" fill="#00A699" />
        <path d="M24.5 17V35M19.5 21.5L24.5 17" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M31 53L45 67L70 36" fill="none" stroke="#fff" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
}
